import Vue from 'vue'
import Router from 'vue-router'
import { isAuthenticated } from "@/utils";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const World = () => import('@/views/World')
const WorldZones = () => import('@/views/WorldZones')
const Asset = () => import('@/views/Asset')
const Poles = () => import('@/views/Poles')
const Assets = () => import('@/views/Assets')
const Zones = () => import('@/views/Zones')
const Login = () => import('@/views/pages/Login')
const Groups = () => import('@/views/Groups')
const Contractors = () => import('@/views/Contractors')
const Stores = () => import('@/views/Stores')
const Building = () => import('@/views/Building')
const Incidents = () => import('@/views/Incidents')


const getRoutes = () => {
  const allRoutes = [
    {
      path: "/",
      component: {
        render (c) { return c('router-view') }
      },
      secured: false,
      children: [
        {
          path: "/",
          name: "Login",
          component: Login
        }
      ],
      props: {
        secured: false
      }
    },
    {
      path: "/dashboard",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/dashboard",
          name: "Dashboard general",
          component: Dashboard
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/stores",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/stores",
          name: "Stores",
          component: Stores
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/building",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/building",
          name: "Building",
          component: Building
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/incidents",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/incidents",
          name: "Incidents",
          component: Incidents
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/contractors",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/contractors",
          name: "contractors",
          component: Contractors
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/poles",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/poles",
          name: "poles",
          component: Poles
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/assets",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/assets",
          name: "Assets",
          component: Assets
        },
        {
          path: ":asset",
          name: "Asset",
          component: Asset
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/world",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/",
          name: "World",
          component: World
        },
        {
          path: "asset/:asset",
          name: "World Asset",
          component: World
        },
        {
          path: "zones",
          name: "World Zones",
          component: WorldZones
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/zones",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/zones",
          name: "Zones",
          component: Zones
        }
      ],
      props: {
        secured: true
      }
    },
    {
      path: "/groups",
      component: TheContainer,
      secured: true,
      children: [
        {
          path: "/groups",
          name: "Groups",
          component: Groups
        }
      ],
      props: {
        secured: true
      }
    }
  ];

  return [...allRoutes];
};

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: getRoutes()
})

router.beforeEach((to, from, next) => {
  if (to) {
    if (!to.matched[0]) {
      if (router.app.$session) {
        router.app.$session.destroy();
      }
      return next("/");
    }
    const path = to.matched[0].path;
    const secured = to.matched[0].props.default.secured;
    isAuthenticated()
      .then(auth => {
        if (secured && auth) {
          next();
        } else if (secured && !auth) {
          if (router.app.$session) {
            router.app.$session.destroy();
          }
          return next("/");
        } else if (path === "" && auth) {
          if (router.app.$session) {
            router.app.$session.destroy();
          }
          return next("/dashboard");
        } else {
          next();
        }
      })
      .catch(() => {
        console.error("Error in isAuth");
      });
  } else {
    next();
  }
})

Vue.use(Router);

export default router;


/*
function configRoutes () {
  return [
    {
      path: '/',
      secured: false,
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'assets',
          name: 'Assets',
          component: Assets
        },
        {
          path: 'world',
          name: 'World',
          component: World,
          children: [
            {
              path: 'asset/:device',
              name: 'Asset',
              component: World
            },
            {
              path: 'zone/:zone',
              name: 'Zone',
              component: World
            }
          ]
        },
        {
          path: 'zones',
          name: 'Zones',
          component: Zones
        },
        {
          path: 'demo',
          name: 'Dashboard Demo',
          component: DashboardDemo
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

*/
